export default __webpack_public_path__ + "static/media/article_4.246bad94.jpg";